import { Locale } from '@lalalilo/enums'
import i18next from 'i18next'

const getBrowserLocale = (): string =>
  i18next.language ||
  window.localStorage.getItem('i18nextLng') ||
  navigator.language

export const getLocale = (): Locale => {
  const language = getBrowserLocale().split('-')[0].split('_')[0].toLowerCase()

  if (language === Locale.FR) {
    return Locale.FR
  }
  return Locale.EN
}
